import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import style from "./NewGhostTable.styles";

function NewGhostTable({
  columns,
  rows,
  headerStyle,
  tableHeadCellStyle,
  align,
  hasAction,
}) {
  return (
    <TableContainer sx={style.container}>
      <Table aria-label="collapsible table" stickyHeader>
        <TableHead
          style={{
            paddingTop: "1.4rem",
            ...headerStyle,
          }}
        >
          <TableRow sx={{ padding: "1rem" }}>
            {columns.map((col) => (
              <TableCell
                key={col.displayName}
                align={align}
                rowSpan={col.rowspan ? col.rowSpan : 1}
                colSpan={col.colSpan ? col.colSpan : 1}
                style={{ ...style.tableHeadCell, ...tableHeadCellStyle }}
              >
                {col.displayName}
              </TableCell>
            ))}
            {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
          </TableRow>
        </TableHead>
        <TableBody sx={style.tableBody}>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
}

const propTypes = {
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  headerStyle: PropTypes.objectOf(),
  hasAction: PropTypes.bool,
  align: PropTypes.string,
  tableHeadCellStyle: PropTypes.objectOf(),
};

const defaultProps = {
  hasAction: false,
  align: "left",
  headerStyle: {},
  tableHeadCellStyle: {},
};

NewGhostTable.propTypes = propTypes;
NewGhostTable.defaultProps = defaultProps;

export default NewGhostTable;
